
<template>
  <div class="text-center loader-wrapper">
    <div class=" text-center loader-inner">
    </div>
    <div class="loader-center">
      <img src="/img/icon.png" class="lazyPage" alt="">
      <p class="text-light text-center" style="margin-top: -50px">درحال بارگذاری...</p>
    </div>

  </div>
</template>
<script>
export default {
  name: "LazyPage"
}
</script>

<style scoped>

</style>